import React from "react";
import { useState, useCallback } from "react";
import logo from "../img/logo.png";
import twitterImg from "../img/twitter.png";
import toast, { Toaster } from "react-hot-toast";
import { EthereumAuthProvider, SelfID } from "@self.id/web";
import { useNavigate, Link } from "react-router-dom";
import getTweetId from "get-tweet-id";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import PropagateLoader from "react-spinners/HashLoader";
import { auth } from "../firebase";
const Social = () => {
  const [modal, setModal] = useState(false);
  const [twitter, setTwitter] = useState("");
  const [url, setUrl] = useState("");
  const { ethereum } = window;
  const [meta, setMeta] = useState("");
  const [did, setDid] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const token = process.env.REACT_APP_BEARER_TOKEN;
  const css1 = `display: block;`;
  const style = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
  const navigate = useNavigate();
  const toggleDown = () => {
    setModal(!modal);
  };
  const toggle = async () => {
    setIsLoading(true);
    const accounts = await ethereum.request({ method: "eth_accounts" });
    const authProvider = new EthereumAuthProvider(window.ethereum, accounts[0]);
    setMeta(accounts[0]);
    const selfid = await SelfID.authenticate({
      authProvider: authProvider,
      ceramic: "https://ceramic.metagame.wtf/",
      connectNetwork: "mainnet",
      threeidConnect: true,
    });
    setDid(selfid.did.id);
    setIsLoading(false);
    setModal(!modal);
  };
  const createTweetLink = useCallback(() => {
    const text = encodeURIComponent(
      `Verifying my Twitter account for my decentralized identity ${did} on @ceramicnetwork via @doxdomxyz.`
    );
    return `https://twitter.com/intent/tweet?text=${text}`;
  }, [did]);

  const getRequest = async () => {
    const twid = await getTweetId(url);
    const params = {
      ids: twid,
      "tweet.fields": "author_id",
    };
    const res = await fetch(
      "https://nameless-bayou-04411.herokuapp.com/https://api.twitter.com/2/tweets?" +
        new URLSearchParams(params),
      {
        headers: {
          "User-Agent": "v2TweetLookupJS",
          authorization: `Bearer ${token}`,
          "X-Requested-With": "XMLHttpRequest",
        },
        method: "GET",
      }
    );
    const rep = await res.json();
    if (rep.data) {
      return rep.data[0];
    } else {
      return -1;
    }
  };
  const getName = async (idofu) => {
    const params = {
      ids: idofu,
    };
    const res = await fetch(
      "https://nameless-bayou-04411.herokuapp.com/https://api.twitter.com/2/users?" +
        new URLSearchParams(params),
      {
        headers: {
          "User-Agent": "v2UserLookupJS",
          authorization: `Bearer ${token}`,
          "X-Requested-With": "XMLHttpRequest",
        },
        method: "GET",
      }
    );
    const rep = await res.json();
    if (rep.data) {
      return rep.data[0].username;
    } else {
      return -1;
    }
  };
  const verify = async () => {
    const toastId = toast.loading("Verifying...");
    const twit = await getRequest();
    if (twit === -1) {
      toast.error("Failed to verify tweet", {
        id: toastId,
      });
      return;
    } else {
      let bool1 = twit.text.includes(did);
      const twname = String(await getName(twit.author_id));
      const str1 = twname.toLowerCase();
      const str2 = twitter.toLowerCase();
      let bool2 = str1 === str2;
      if (bool1 && bool2) {
        toast.success("Attestation added!", { id: toastId });
        updateDoc(doc(db, "users", auth.currentUser.uid), {
          tweetHandle: twitter,
        });
        navigate("/success");
      } else {
        toast.error("Failed to verify tweet", {
          id: toastId,
        });
      }
    }
  };

  return (
    <div className="social">
      <Toaster position="top-center" reverseOrder={false} />
      {isLoading && (
        <div className="modal">
          <PropagateLoader
            color={"#4d00ac"}
            isLoading={isLoading}
            css={css1}
            size={60}
            style={style}
          />
        </div>
      )}
      {modal && (
        <div className="modal">
          <div className="overlay" onClick={toggleDown}></div>
          <div className="content">
            <div className="step-1">
              <div className="sp-con">
                <span>Step-1</span>
                <div className="inpx">
                  <span className="sp1">Enter your twitter username @</span>
                  <input
                    type="text"
                    placeholder=""
                    className="twitterHandle"
                    onChange={(e) => setTwitter(e.target.value)}
                  />
                </div>
              </div>
              <div className="btndiv">
                <a href={createTweetLink()} target="_blank">
                  <button onClick={createTweetLink()}>Tweet</button>
                </a>
              </div>
            </div>
            <div className="step-2">
              <div className="sp-con">
                <span>Step-2</span>
                <div className="inpx">
                  <span className="sp2">Paste the Tweet URL and verify</span>
                  <input
                    type="text"
                    placeholder=""
                    className="twitterHandle"
                    onChange={(e) => setUrl(e.target.value)}
                  />
                </div>
              </div>
              <div className="btndiv">
                <button onClick={verify}>Verify</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <div className="name">
          <img src={logo} alt=""></img>
        </div>
        <div className="steps">
          <div className="step">Step 1</div>
          <hr></hr>
          <div className="step">Step 2</div>
          <hr></hr>
          <div className="stepf">Step 3</div>
        </div>
        <div className="medias">
          <span className="connect">Connect your social media accounts</span>
          <div className="buttons">
            <div className="twitter">
              <div className="nameImg">
                <img src={twitterImg} alt="" />
                <span>Twitter</span>
              </div>
              <div className="connButton">
                <button onClick={toggle}>
                  <span>Connect</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Social;
